import React, { Component } from "react";
import config from "lib/fr-config";
import CommonIconView from "presentational/common/CommonIconView";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";

/** 파일 입력 버튼의 라벨 용도로 사용시 <button> element 는 작동하지 않아서 <span> 으로 사용중. */
const BTN_COMPONENT = "span";

const colorCss = config.css.color;

const CustomIconButton = withStyles({
  root: {
    borderRadius: "initial",
    padding: 0
  }
})(IconButton);

class IconButtonView extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,

    buttonSize: PropTypes.oneOf(["small", "large"]),
    fontSize: PropTypes.oneOf(["xsForMinorText", "small", "medium", "large"]),
    color: PropTypes.oneOf(["primary", "fontColor", "forPick", "default"]),
    disableTopMargin: PropTypes.bool,
    disableBottomMargin: PropTypes.bool,
    disableLeftMargin: PropTypes.bool,
    disableRightMargin: PropTypes.bool,
    invisible: PropTypes.bool
  };

  static defaultProps = {
    buttonSize: "large",
    fontSize: "large",
    color: "default",
    disableTopMargin: false,
    disableBottomMargin: false,
    disableLeftMargin: false,
    disableRightMargin: false,
    invisible: false
  };

  getIconStyle() {
    const { fontSize, color, invisible } = this.props;
    return {
      fontSize:
        fontSize === "xsForMinorText"
          ? 14
          : fontSize === "small"
          ? 20
          : fontSize === "medium"
          ? 28
          : fontSize === "large"
          ? 36
          : 0,
      color: invisible
        ? colorCss.colorOfBackground
        : color === "primary"
        ? colorCss.colorOfPrimary
        : color === "fontColor"
        ? colorCss.colorOfMainText
        : color === "forPick"
        ? colorCss.colorOfPick
        : colorCss.colorOfCommonIcon
    };
  }

  getButtonStyle() {
    const {
      buttonSize,
      disableTopMargin,
      disableBottomMargin,
      disableLeftMargin,
      disableRightMargin
    } = this.props;
    const paddingPx =
      buttonSize === "small" ? 1 : buttonSize === "large" ? 12 : 0;
    return {
      padding: paddingPx,
      marginTop: disableTopMargin ? -paddingPx : undefined,
      marginBottom: disableBottomMargin ? -paddingPx : undefined,
      marginLeft: disableLeftMargin ? -paddingPx : undefined,
      marginRight: disableRightMargin ? -paddingPx : undefined
    };
  }

  getIcon() {
    const { type } = this.props;
    const style = this.getIconStyle();
    return <CommonIconView type={type} style={style} />;
  }

  render() {
    const { invisible, onClick } = this.props;
    const style = this.getButtonStyle();

    return (
      <CustomIconButton
        onClick={onClick}
        style={style}
        disabled={invisible}
        component={BTN_COMPONENT}
      >
        {this.getIcon()}
      </CustomIconButton>
    );
  }
}

export default IconButtonView;
